module.exports = __webpack_public_path__ + "img/顶部搜素图标.832a4e1f.png";